<template>
    <div class="select_item_type">
        <div>
            <p>商品の種類を選択してください</p>
            <div>
                <button @click="setItem(CONST.ITEM_TYPE_CURTAIN, CONST.CURTAIN_TYPE_DOUBLE)">カーテン(両開き)</button>
<!--                <button @click="setItem(CONST.ITEM_TYPE_CURTAIN, CONST.CURTAIN_TYPE_SINGLE)">カーテン(片開き)</button>-->
                <button @click="setItem(CONST.ITEM_TYPE_CURTAIN, CONST.CURTAIN_TYPE_PLANE_SHADE)">カーテン(プレーンシェード)</button>
<!--                <button class="disable">横型ブラインド</button>-->
<!--                <button class="disable">縦型ブラインド</button>-->
<!--                <button @click="setItem(CONST.ITEM_TYPE_CURTAIN, null)">カーテン</button>-->
<!--                <button class="disable" @click="setItem(CONST.ITEM_TYPE_FLOOR)">床材</button>-->
                <button @click="setItem(CONST.ITEM_TYPE_CURTAIN, CONST.CURTAIN_TYPE_ROLL_SCREEN)">ロールスクリーン</button>
                <button @click="setItem(CONST.ITEM_TYPE_CURTAIN, CONST.CURTAIN_TYPE_LINE_DRAPE)">ラインドレープ</button>
                <button @click="setItem(CONST.ITEM_TYPE_WALL)">壁紙</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
    import CONST from '../../../assets/js/const'
    import Util from '../../../assets/js/util'
    const {EDIT_CIRCLE_RADIUS, EDIT_RECT_SIZE} = CONST;

    export default {
        name: "SelectItemType",
        data: () => ({
            CONST,
            curtain2: [[15,10], [85,10], [15,65], [85,65]], //初期座標
        }),
        props: ["mode"],
        computed: {
            ...mapState('item_data', ["curtain_data", "wall_data", "floor_data", ]),
            ...mapState('simulator', ["editing_id"]),
        },
        methods: {
            ...mapMutations(["setModal"]),
            ...mapMutations('simulator', ["createTempItem", "updateTempItem", "setIsContinuingLoading"]),
            ...mapActions('simulator', ["updateItemInfo"]),
            async setItem(item_type, curtain_type) {
                if (item_type !== CONST.ITEM_TYPE_CURTAIN) curtain_type = null;

                //この段階でカーテンか壁紙かは確定する
                //それによって読み込まれるテクスチャも違うため
                if(this.mode == "add"){
                    this.createTempItem();
                    this.updateTempItem({
                        points: {
                            top_left:     {x: EDIT_CIRCLE_RADIUS, y: EDIT_CIRCLE_RADIUS},
                            top_right:    {x: EDIT_RECT_SIZE,     y: EDIT_CIRCLE_RADIUS},
                            bottom_left:  {x: EDIT_CIRCLE_RADIUS, y: EDIT_RECT_SIZE},
                            bottom_right: {x: EDIT_RECT_SIZE,     y: EDIT_RECT_SIZE},
                        },
                        rect_width: this.getRectWidthFromItemType(item_type),
                        item_type,
                        curtain_type,
                    });
                    //this.$emit('nextStep');
                    await this.setIsContinuingLoading(true);
                    this.setPosition(this.curtain2);

                    //デフォルト柄を設定
                    const default_texture = this.curtain_data[0];
                    await this.setIsContinuingLoading(false);
                    await this.updateItemInfo({id: this.editing_id, item_data: default_texture});

                }else if(this.mode == "change"){
                    await this.updateItemInfo({id: this.editing_id, curtain_type});
                    this.$emit('endStep');
                }

            },
            getRectWidthFromItemType(item_type) {
                switch (item_type) {
                    case CONST.ITEM_TYPE_CURTAIN: { return 200; }
                    case CONST.ITEM_TYPE_WALL: { return 300; }
                    case CONST.ITEM_TYPE_FLOOR: { return 400; }
                }
            },
            async setPosition(points) {
                const calculated_points = Util.calculatePoint(points);
                this.updateTempItem({points: calculated_points});
                this.$emit('endStep');
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../assets/css/define";

    *{margin: 0}

    .select_item_type{
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        >div{
            height: 100%;
            p{
                height: 10%;
                font-size: 1vw;
            }
            >div{
                display: flex;
                flex-direction: column;
                height: 90%;
                justify-content: space-between;
                align-items: center;
            }
        }
    }

    button{
        position: relative;
        cursor: pointer;
        background-color: #fff;
        transition: 0.3s;
        border: 1px solid #040404;
        border-radius: 5px;
        width: 100%;
        height: calc(20% - 5px);
        font-size: 1vw;
        &.disable {
            cursor: default;
        &:after{
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            background-color: rgba(0,0,0,0.5);
        }
        }
        &:hover{
            background-color: #040404;
            color: #fff;
        }

    }
</style>
